import { render, staticRenderFns } from "./AddForm.vue?vue&type=template&id=0818dad4&scoped=true"
import script from "./AddForm.vue?vue&type=script&lang=js"
export * from "./AddForm.vue?vue&type=script&lang=js"
import style0 from "./AddForm.vue?vue&type=style&index=0&id=0818dad4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0818dad4",
  null
  
)

export default component.exports